import { useEffect, useState } from 'react';
import MuiDialog from '../../../UI/MuiDialog/MuiDialog';
import DecimalInput from '../../../UI/FormControls/DecimalInput';

const EditPhaseProgressDialog = ({
  open,
  handleClose,
  handleConfirm,
  phaseLabel,
  initialProgres,
  loading,
}) => {
  const [progres, setProgres] = useState('');

  useEffect(() => {
    if (open) {
      setProgres(
        initialProgres !== undefined && initialProgres !== null
          ? String(initialProgres)
          : '',
      );
    }
  }, [open, initialProgres]);

  const handleProgresChange = (values) => {
    setProgres(values.value);
  };

  const onConfirm = () => {
    handleConfirm(progres === '' ? 0 : parseFloat(progres));
  };

  return (
    <MuiDialog
      open={open}
      handleClose={handleClose}
      handleConfirm={onConfirm}
      title={phaseLabel}
      maxWidth="xs"
      loading={loading}
      content={
        <div style={{ marginTop: '8px' }}>
          <DecimalInput
            label="Progres"
            name="progres"
            value={progres}
            handleChange={handleProgresChange}
            decimalScale={2}
            style={{ width: '100%' }}
          />
        </div>
      }
    />
  );
};

export default EditPhaseProgressDialog;
